export default __webpack_public_path__ + "static/media/b_problemSolving_large.4fe94c53.png";